import { render, staticRenderFns } from "./StockMain.vue?vue&type=template&id=718707c6&"
import script from "./StockMain.vue?vue&type=script&lang=js&"
export * from "./StockMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports